import React, { Component, Fragment } from 'react'
import Equalizer from 'react-equalizer'

class CrossText extends Component {
    buildClasses(isLeft) {
        const left = isLeft ? 'text-left' : 'text-right'
        const backgrounds = this.props.hasBackgrounds ? 'cross-no-bg' : 'cross-bg'
        return left + ' ' + backgrounds
    }

    renderParts() {
        const { data, title, css } = this.props
        let isLeft = false

        return (
            <div className="container">
                <div className="container">
                    <div className={`row text-center cross-text ${css}`}>
                        <div className=" text-center" style={{ margin: 'auto' }}>
                            {title && <h2 className="text-center lined">{title}</h2>}
                        </div>
                        <br className="clearfix" />
                        <div className="row">
                            <Equalizer byRow={false}>
                                {
                                    data.map((part, key) => {
                                        isLeft = !isLeft
                                        return (
                                            <div key={key} className={this.buildClasses(isLeft)}>
                                                <div style={{ width: '100%' }}>
                                                    <h4>{part.title}</h4>
                                                    <div dangerouslySetInnerHTML={{ __html: part.text }} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Equalizer>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                {this.renderParts()}
            </Fragment>
        )
    }
}

export { CrossText }


// WEBPACK FOOTER //
// ./src/components/sections/CrossText.js